import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// ============================================================
// Firebase Configurations
// ============================================================
const devfirebaseConfig = {
  apiKey: "AIzaSyDNZecSQQqenrsGVeR5TukoZy2Fwi7gYOM",
  authDomain: "qarl-studio.firebaseapp.com",
  projectId: "qarl-studio",
  storageBucket: "qarl-studio.firebasestorage.app",
  messagingSenderId: "1093867875731",
  appId: "1:1093867875731:web:a012a9fd5a20e57b100c66",
  measurementId: "G-PZ6SMGY8PD"
};

const qafirebaseConfig = {
  apiKey: "AIzaSyDBgSaKB4OsciWB84VtuJq_snyYWWg1MDo",
  authDomain: "qarl-studio-qa.firebaseapp.com",
  projectId: "qarl-studio-qa",
  storageBucket: "qarl-studio-qa.firebasestorage.app",
  messagingSenderId: "449606684270",
  appId: "1:449606684270:web:e882cc6eeb74a3e00b207f",
  measurementId: "G-LS4DKG2KZ7"
};

const prodfirebaseConfig = {
  apiKey: "AIzaSyC-BfmONdGR5Gv2FscreFGUbgAxmMKMPms",
  authDomain: "prod-qarl-studio.firebaseapp.com",
  projectId: "prod-qarl-studio",
  storageBucket: "prod-qarl-studio.firebasestorage.app",
  messagingSenderId: "334655833723",
  appId: "1:334655833723:web:5270ba92d8d435637484de",
  measurementId: "G-9JG2JS1H2D"
};

// ============================================================
// Environments
// ============================================================
const ENV_KEY = 'qarl_environment';

export const ENVIRONMENTS = {
  dev:  { label: 'Dev',  apiBase: 'https://qarl-studio-backend-api.qarl.dev/studio-api', firebase: devfirebaseConfig },
  qa:   { label: 'QA',   apiBase: 'https://qarl-studio-qa-api.qarl.dev/studio-api', firebase: qafirebaseConfig },
  prod: { label: 'Prod', apiBase: 'https://studio-prod-api.qarl.dev/studio-api', firebase: prodfirebaseConfig },
};

// ============================================================
// State
// ============================================================
let currentEnv = localStorage.getItem(ENV_KEY) || 'dev';
if (!ENVIRONMENTS[currentEnv]) currentEnv = 'dev';

let app = initializeApp(ENVIRONMENTS[currentEnv].firebase);
let auth = getAuth(app);
let firestore = getFirestore(app);

// ============================================================
// Getters
// ============================================================
export const getCurrentEnv = () => currentEnv;
export const getApiBase = () => ENVIRONMENTS[currentEnv].apiBase;
export const getFirebaseAuth = () => auth;
export const getFirestoreDb = () => firestore;

// ============================================================
// Switch environment (reinitializes Firebase)
// ============================================================
export const switchFirebaseApp = (envKey) => {
  if (!ENVIRONMENTS[envKey]) return;
  if (envKey === currentEnv) return;

  currentEnv = envKey;
  localStorage.setItem(ENV_KEY, envKey);

  deleteApp(app).catch(() => {});
  app = initializeApp(ENVIRONMENTS[envKey].firebase);
  auth = getAuth(app);
  firestore = getFirestore(app);
};
